import { AnbPaymentDetails } from './AnbPaymentDetails';

export function AnbTab() {
  return <AnbPaymentDetails />;
}
